import { UserContext, UserContextInterface } from 'client';

export const UserContextSingleton = (function () {
  let instance;

  return {
    getInstance: function (): UserContextInterface {
      if (!instance) {
        instance = new UserContext();
      }
      return instance;
    },
  };
})();
